import { render, staticRenderFns } from "./settingFreshDistributionBase.vue?vue&type=template&id=30a6011e&scoped=true"
import script from "./settingFreshDistributionBase.vue?vue&type=script&lang=js"
export * from "./settingFreshDistributionBase.vue?vue&type=script&lang=js"
import style0 from "./settingFreshDistributionBase.vue?vue&type=style&index=0&id=30a6011e&prod&lang=less&scoped=true"
import style1 from "./settingFreshDistributionBase.vue?vue&type=style&index=1&id=30a6011e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a6011e",
  null
  
)

export default component.exports